<template>
  <span v-if="color" :style="[color ? { 'color': color } : { }]">
    <font-awesome-icon v-for="star in stars"
                      :key="star.id"
                      :icon="getStyle(star)" />
  </span>
</template>

<script>
  export default {
    props: {
      score: { default: 30 },
      minStars: { type: Number, default: 0 },
      maxStars: { type: Number, default: 5 },
      color: { type: String, default: '#0066B1' }
    },

    data() {
      return {
        stars: [
          { id: 0, state: 1 },
          { id: 1, state: 1 },
          { id: 2, state: 1 },
          { id: 3, state: 2 },
          { id: 4, state: 0 }
        ],
        max: 5
      }
    },

    mounted() {
      if (this.score == "n/a" || this.score > this.max) {
        this.stars.forEach(item => {
          item.state = 9;
        });
        return;
      }

      let items = [
        {id: 0, state: 0},
        {id: 1, state: 0},
        {id: 2, state: 0},
        {id: 3, state: 0},
        {id: 4, state: 0}
      ];
      for (let index = 0; index < Math.floor(this.score); index++) {
        items[index].state = 1;
      }

      if  (this.score != Math.floor(this.score)) {
        if ((this.score - Math.floor(this.score)) * 4 >= 1) {
          items[Math.floor(this.score)].state = 2;
        }
      }

      this.stars = items;
    },

    methods: {
      getStyle(key) {
        switch (key.state) {
          case 1:
            return ['fas', 'star'];
          case 0:
            return ['far', 'star'];
          case 9:
            return ['far', 'star-exclamation'];
          default:
            return  ['fas', 'star-half-alt'];
        }
      }
    }
  }

</script>
